/** Design System — Responsive breakpoints (px, min-width). */
export const breakpoint = {
  mobile: 320,
  tablet: 768,
  laptop: 1024,
  desktop: 1440,
  wide: 1920,
} as const;

export type Breakpoint = typeof breakpoint;

/** Convenience min-width media query strings. */
export const mediaUp = {
  tablet: `(min-width: ${breakpoint.tablet}px)`,
  laptop: `(min-width: ${breakpoint.laptop}px)`,
  desktop: `(min-width: ${breakpoint.desktop}px)`,
  wide: `(min-width: ${breakpoint.wide}px)`,
} as const;
